<template>
    <svg
        id="Card"
        xmlns="http://www.w3.org/2000/svg"
        width="23.136"
        height="19.605"
        viewBox="0 0 23.136 19.605"
    >
        <path
            id="Pfad_356"
            data-name="Pfad 356"
            d="M18.694,8.728H14.2a.836.836,0,0,1,0-1.67h4.5a.836.836,0,0,1,0,1.67"
            transform="translate(-0.475 1.942)"
            :class="fillClass + ' transition-fill'"
        />
        <path
            id="Pfad_354"
            data-name="Pfad 354"
            d="M21.764,19.6H1.37A1.385,1.385,0,0,1,0,18.21V1.394A1.385,1.385,0,0,1,1.37,0H21.764a1.386,1.386,0,0,1,1.372,1.394V18.21a1.385,1.385,0,0,1-1.372,1.4M1.642,17.935H21.494V1.67H1.642Z"
            :class="fillClass + ' transition-fill'"
        />
        <path
            id="Pfad_408"
            data-name="Pfad 408"
            d="M18.694,8.728H14.2a.836.836,0,0,1,0-1.67h4.5a.836.836,0,0,1,0,1.67"
            transform="translate(-0.475 -2.058)"
            :class="fillClass + ' transition-fill'"
        />
        <path
            id="Pfad_357"
            data-name="Pfad 357"
            d="M18.694,13.218H14.2a.836.836,0,0,1,0-1.67h4.5a.836.836,0,0,1,0,1.67"
            transform="translate(-0.475 1.452)"
            :class="fillClass + ' transition-fill'"
        />
    </svg>
</template>
<script>
import { defineComponent } from "vue";

export default defineComponent({
    name: "CouponIcon",
    props: {
        fillClass: {
            type: String,
            required: true,
        },
    },
});
</script>
